import React, { FC } from 'react';

import { useShowBottomMenu, useNavBehavior } from './helpers/hooks';
import { StyledNavigation } from './styled';

import LeftMenu from './LeftMenu';
import BottomMenu from './BottomMenu';
import ProfileFloatingMenu from './BottomMenu/ProfileFloatingMenu';
import RightMenu from './RightMenu';

const Navigation: FC = () => {
  const { isHide, bgColor, fontColor } = useNavBehavior();
  const showBottomMenu = useShowBottomMenu();

  return (
    <>
      <StyledNavigation id="navigation-container" color={fontColor} isHide={isHide} bgColor={bgColor}>
        <LeftMenu />
        <RightMenu />
      </StyledNavigation>
      {showBottomMenu && (
        <>
          <ProfileFloatingMenu variant="profile" />
          <ProfileFloatingMenu variant="discovery" />
          <BottomMenu />
        </>
      )}
    </>
  );
};

export default Navigation;
